
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DatasetRepo, Dimension, uuidv4 } from '@gspwidget/util';
import { WidgetPropertyService } from '@gspwidget/widget-core';
import { FilterSchema } from '@gspwidget/widget-devkit';
import { DataField, PropertyOption, PropertyTypes } from '@gspwidget/widget-devkit';
import { TranslateService } from '@ngx-translate/core';
import { path } from 'change-case';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { map } from 'rxjs/operators';
import { FeFilterModalComponent } from '../../fe-filter-modal/fe-filter-modal.component';
import { HelpService } from '../../help/help.service';
import { XcHelpService } from '../../help2/help.service';
import { CEContext, PropertyChangeEvent, PropsAndValues } from '../../types';

@Component({
  selector: 'ce-item',
  templateUrl: './ce-item.component.html'
})
export class CeItemComponent implements OnInit {
  @Input() context: CEContext
  /**
   * æ¯å¦æ¾ç¤º label
   * ä¸»è¦ç¨äºæ°ç»ï¼ä¸éè¦ç»æ°ç»é¡¹æ¾ç¤º labelã
   */
  @Input() showLabel = true
  /** æ ä¸è¾¹è·ãç¨äºæ°ç»é¡¹éç ce-itemï¼æ ä¸è¾¹è·ã */
  @Input() mb0 = false

  // æ³¨ææ¯å¦æçéè¦é²æãå»¶è¿è§¦å valueChange
  @Input() set propAndValue (v: { prop: PropertyOption, value: any }) {
    if (!v) return
    const { prop, value } = v
    if (prop === this.prop) return

    this.prop = prop
    this.value = value

    switch (prop.type) {
      case PropertyTypes.DataField:
        // å¼å®¹ string ç±»åçèæ°æ®
        if (typeof value === 'string') {
          this.value = { name: value, label: value }
          this.handleChangeDataFieldValue(value)
        // } else if (value) {
        //   this.curCol = this.findColInAggByName(value.name)
        }
        break
      case PropertyTypes.Color:
        break
      case PropertyTypes.Object:
        this.objPropsAndValues = {
          props: Object.values(this.prop.objectOption.objPropertyOptions),
          propValues: value
        }
        break
      case PropertyTypes.Text:
      // case PropertyTypes.DataField:
        this.formControl = new FormControl(value, { updateOn: 'blur' })
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.Number:
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.SelectHelp:
        const { url, body } = prop.selectHelpOption
        if (prop.selectHelpOption.usePost) {
          this.http.post(url, body).subscribe(this.handleLoadedSelectHelpData)
        } else {
          this.http.get(url).subscribe(this.handleLoadedSelectHelpData)
        }
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.Bool:
      case PropertyTypes.Enum:
      default:
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
    }
    if (prop.type === PropertyTypes.Bool) {
      this.id = uuidv4()
    }
  }
  /** å¼ååäºä»¶ */
  @Output() onChangeValue = new EventEmitter()


  /** å½å item å±æ§è¯¦æ */
  prop: PropertyOption
  /** å½å item ç valueï¼ç¨äºæ¸²æå½åå¼ */
  value: any
  /** input, select */
  formControl: FormControl
  /** checkbox éè¦ id åºå  */
  id: string
  /** Object */
  objPropsAndValues: PropsAndValues
  /** SelectHelp */
  selectHelpData: any[]
  /** Data Field */
  // dataFields = ['aa', 'bbb', 'cccc']
  /** color */
  colors: string[]

  PropertyTypes = PropertyTypes

  /** Select Help çæ°æ®å è½½å®æ */
  handleLoadedSelectHelpData = (res: any[] | any) => {
    // this.formControl = new FormControl()
    // this.formControl.valueChanges.subscribe(this.handleChangeValue)

    if (Array.isArray(res)) this.selectHelpData = res
    if (Array.isArray(res.data)) this.selectHelpData = res.data

    // ä¿å­ç»æãæ¸²æ
    // this.selectHelpData = res
    this.cd.detectChanges()
    // åé»è®¤å¼ï¼æé  formControlï¼æ³¨ååååè°
    // let isStringArray = typeof this.selectHelpData === 'string'
    // let initValue = this.value
    //   || this.prop.selectHelpOption.default
    //   || (isStringArray ? this.selectHelpData[0] : this.selectHelpData[0][this.prop.selectHelpOption.valueField])
    // this.formControl = new FormControl(initValue)
    // this.formControl.valueChanges.subscribe(this.handleChangeValue)
  }
  // all
  handleChangeValue = (newValue: any) => {
    this.value = newValue
    this.onChangeValue.emit(this.value)
  }

  constructor (
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private help: HelpService,
    public widgetProperty: WidgetPropertyService,
    private modal: NzModalService,
    private translate: TranslateService,
    private datasetRepo: DatasetRepo,
    private help2: XcHelpService,
  ) { }

  ngOnInit () {
    // TODO: åºè¯¥æè¿ä¸ª item ææä¸ä¸ªä¸ªå°çç»ä»¶
    // if() debugger
    if (this.prop.type === PropertyTypes.Color) {
      this.colors = this.widgetProperty.getColorsByColorOption(this.prop.colorOption)
    }
  }

  // object
  handleChangeObjectValue (e: PropertyChangeEvent) {
    const { propName, value } = e
    this.value[propName] = value
    this.onChangeValue.emit(this.value)
  }

  // dataField
  oldPlainString: string
  // TODO: è¿éåºç°äº aggï¼ä¸é£ä¹å¬å±äºï¼é½ä¸æ¢ç¨ Agg ç±»åãèèéæã
  /**
   * ç¹å» auto ä¼è°ç¨ï¼è¾å¥æ¡ blur ä¹ä¼è°ç¨ï¼æä»¥æ³¨æå°½éä¸éå¤ååºåä¸ä¸ªå¼ã
   * data field æåµä¸ï¼value æ¢å¯è½æ¯ nameï¼ä¹å¯è½æ¯ labelï¼éè¦å» cols ä¸­å¹éåº dataField
   */
  handleChangeDataFieldValue (plainString: string) {
    if (this.oldPlainString === plainString) return
    this.oldPlainString = plainString
    if (this.context.extra.agg) {
      // TODO: é»è¾æäºè¿æ¶äº
      // å¦æ agg æå­æ®µï¼æåå°±ä¸èµ·ä½ç¨
      const { cols, computedCols } = this.context.extra.agg
      if ([...cols, ...computedCols].length > 0) return 
      const col = [...cols, ...computedCols].find(c => c.name === plainString || c.label === plainString)
      if (col) { // è½å¹éå° colï¼å°±ç¨ col ç
        const { name, label } = col
        this.value = { name, label } as DataField
        this.onChangeValue.emit(this.value)
      } else {
        this.value = { name: plainString, label: plainString } as DataField
        this.onChangeValue.emit(this.value)
      }
    } else {
      this.value = { name: plainString, label: plainString } as DataField
      this.onChangeValue.emit(this.value)
    }
  }
  handleSelectCol (colName: string) {
    const col = this.findColInAggByName(colName)
    // æå¤è¯­ label å­èµ·æ¥ï¼wc è´è´£è§£æ
    this.value = {
      name: col.name,
      label: col.i18nLabel,
    }
    this.onChangeValue.emit(this.value)
  }
  getColShowLabel (name: string, i18nLabel: any | string) {
    // console.count()
    if (!i18nLabel) return name
    if (typeof i18nLabel === 'string') return i18nLabel
    if (i18nLabel[this.translate.currentLang]) return i18nLabel[this.translate.currentLang]
    return name
  }
  private findColInAggByName (name: string): Dimension {
    if (!this.context.extra || !this.context.extra.agg) return
    const { cols, computedCols } = this.context.extra.agg
    // if ([...cols, ...computedCols].length > 0) return 
    return [...cols, ...computedCols].find(c => c.name === name || c.label === name)
  }

  // help
  handleClickOpenHelp () {
    const { helpOption, displayName } = this.prop
    const { getData, structure, tableFields, valueField, nameField, getTableOnSelectTree } = helpOption
    this.help.show({
      title: `è¯·éæ©`,
      structure,
      tableFields,
      nameField,
      getData: getData ? () => getData(this.http) : null,
      // getTree: getTree ? () => getTree(this.http) : null,
      getTableOnSelectTree: getTableOnSelectTree ? (clickedNode) => getTableOnSelectTree(clickedNode, this.http) : null
    }).subscribe(item => {
      this.formControl.setValue(item[nameField])
      this.handleChangeValue({
        __type: 'help',
        value: item[valueField],
        name: item[nameField]
      })
    })
  }
  handleHelp2ValueChange (result) {
    const { valueField, labelField } = this.prop.help2Option
    // å¤é
    if (Array.isArray(result)) {
      this.value = {
        __type: 'help',
        value: result.map(item => item[valueField]),
        label: `å·²éæ© ${result.length} é¡¹`,
      }
    } else { // åé
      this.value = {
        __type: 'help',
        value: result[valueField],
        label: result[labelField]
      }
    }
    this.handleChangeValue(this.value)
  }
  handleClickOpenFilter () {
    const agg = this.context.extra
    const dims = agg
      ? [...(agg.cols || []), ...(agg.computedCols || [])]
      : []
    const modalRef: NzModalRef<FeFilterModalComponent> = this.modal.create({
      nzTitle: 'ç­ééç½®',
      nzContent: FeFilterModalComponent,
      nzComponentParams: {
        // dims,
        // getIntactData: () => {
        //   return this.datasetRepo
        //     .getAggResultByAgg(agg)
        //     .pipe(map(aggResult => aggResult.tableData))
        // },
        fs: this.value || new FilterSchema()
      },
      nzWidth: 600,
      nzClassName: 'body-p-vert-0',
      nzFooter: [{
        label: this.translate.translations[this.translate.currentLang]['cancel'],
        shape: 'default',
        onClick: () => modalRef.destroy()
      }, {
        label: this.translate.translations[this.translate.currentLang]['confirm'],
        type: 'primary',
        // disabled: () => true,
        onClick: () => {
          const { fs: filterSchema } = modalRef.getContentComponent()
          // æ­¤æ è®°ç¨äºé²æ­¢ wc æ pvs ä¸­ç i18n å­æ®µå¤çæä»å½åè¯­è¨çå­ç¬¦ä¸²ã
          // TODO: æ¯ä¸æ¯å¯ä»¥å¨ç­éç»ä»¶éå¤çï¼å¦æ i18nName æ¯å­ç¬¦ä¸²ï¼åç´æ¥æ¾ç¤ºå®ï¼
          filterSchema.i18nName._notProcess = true
          this.handleChangeValue({ ...filterSchema })
          modalRef.destroy()
          // this.cd.detectChanges()
        }
      }]
    })
  }

  // scss
  handleBlurScss () {
    this.handleChangeValue(this.value)
  }

  editorWin: Window
  handleOpenEditor (lang: string) {
    // çªå£å·²ç»æå¼äºå°±å°åé¢æ¥ï¼ç°å¨æ²¡æçªå£å°±éå¼ä¸ä¸ª
    if (this.editorWin && !this.editorWin.closed) {
      this.editorWin.focus()
    } else {
      this.editorWin = openEditorWindowService({
        xcInitialContent: this.value,
        xcLang: lang,
        xcOnConfirm: (value: string) => {
          // alert(value)
          console.log(value)
          this.value = value
          this.handleChangeValue(this.value)
          // this.cd.detectChanges()
          if (window['cd']) window['cd'].detectChanges()
        }
      })
    }
  }
}

function openEditorWindowService (opt: {
  xcInitialContent?: string,
  xcLang?: string,
  xcOnChange?: (value: string) => void
  xcOnConfirm?: (value: string) => void
}) {
  const { xcInitialContent, xcLang, xcOnChange, xcOnConfirm } = opt
  const editorWin = window.open('/platform/runtime/sys/web/home/assets/xc-editor.html', null, 'popup, width=600, height=600, left=2000, top=200')
  editorWin['xcEditorApi'] = {
    xcInitialContent,
    xcLang,
    xcOnConfirm,
    xcOnChange,
  }
  window['aa'] = editorWin
  return editorWin
}
